import welciaAMd from '../content/welcia/a.md?raw'
import welciaBMd from '../content/welcia/b.md?raw'
import cMd from '../content/c.md?raw'
import dMd from '../content/d.md?raw'
import escalationMd from '../content/escalation.md?raw'
import appendixMd from '../content/appendix.md?raw'
import { GuideSection, GuideVariant, section } from '../core'
import { ContactNote } from '../components/ContactNote'

/**
 * ウエルシア（/guide/welcia）。AutoScanHelper が入っている唯一の系統なので A・B だけ個別。
 *
 * AutoScanHelper は給紙を見て自動でスキャンを起こす常駐アプリで、配布物に含むのは
 * ウエルシアだけ。そのため次の 3 つはこの版にしか無い。
 *
 * - A の区分タイトルの「接続不能」と A-2（［はい］で再試行・「ソースの選択」）。
 *   どちらも AutoScanHelper が出す画面。
 * - A-3 / B-3 の AutoScanHelper の立ち上げ直し。
 * - 表面の「Scan ボタンは押さなくて大丈夫です」（紙の A4 シートも同じ）。
 *
 * 機材（fi-800R キット）と QuickSync・レセコン連携は直販と同じなので、C・D・
 * それでも解決しないとき・付録は共有版と同文。
 *
 * 一次窓口はコールセンター（CRC）への電話。番号は顧客ごとに違うので web には書かず、
 * 配布シート（法人版PDF）が持つ。紙のA4シート裏面のQR/URLはこのパスを指す
 * （localStorage の app type に依存しないため、未使用ブラウザでもメール窓口に落ちない）。
 */
export const WELCIA_SECTIONS: GuideSection[] = [
  // A〜D のタイトルは紙のシート裏面（Figma）と逐語一致させること
  section({
    id: 'a',
    label: 'A',
    title: 'スキャンできない /「接続不能」と出る',
    body: welciaAMd,
  }),
  section({
    id: 'b',
    label: 'B',
    title: 'スキャンしたのに まもる君web・レセコンに出ない',
    body: welciaBMd,
  }),
  section({
    id: 'c',
    label: 'C',
    title: 'まもる君web にログインできない',
    body: cMd,
  }),
  section({
    id: 'd',
    label: 'D',
    title: '読み取った内容がちがう',
    body: dMd,
  }),
  section({
    id: 'escalation',
    title: 'それでも解決しないとき',
    body: escalationMd,
  }),
  section({
    id: 'appendix',
    title: '付録',
    body: appendixMd,
  }),
]

export const welciaVariant: GuideVariant = {
  sections: WELCIA_SECTIONS,
  contact: (
    <ContactNote>
      コールセンターへお電話ください
      （電話番号はお手元の配布シートに記載しています）。
    </ContactNote>
  ),
}
